import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Default expected files that can be used as fallback
const DEFAULT_EXPECTED_FILES = {
    'This Organization needs to be onboarded': [],
};

// Organization-specific expected files configuration
export const ORG_EXPECTED_FILES_WITH_HEADERS = {
    '2': {
        'Card Extract': [
            'Location','Service','Surgeon','Proc code','Preference ID','Procedure','Med ID','Amt','Unit','Lawson','Manuf','Type','Description','Open','PRN/Needed','Unit Cost'
        ],
        'Usage Extract': [
            'Hospital Account ID','Surgical Case ID','Surgical Location','First Procedure ID','First Procedure Name','Hospital','Surgery Date','Latest PickList Log Date',
            'Primary Surg ID','Primary Surg Name','Preference Card ID','Supply Type','Mfr ID','Mfr Name','Model NBR','Mfr Prod #','Line','Pick List ID','SUP .1',
            'Vendor Supply ID','Supply Name','# Open','# PRN','# Wasted','# Used','OpTime Cost','Vendor Cost','Extended Cost (used in Average Cost Calcuations)',
            'Purchase Item Group Code','Purchase Item Group','Primary ICD Procedure','Primary ICD Diagnosis','Primary Surgeon Group','Action','Surgical Service','OR Comments',
            'Pick List Type','Item Type','Implant ID','Implant Status','Implant Model Number','Implant Serial Number','Implant Log Number','Implant Type'
        ],
        'Procedure Index': [
            'Locations','Surgeon','Procedures','Responsible Service','Card #','Creation Date','Last Used','Notes'
        ],
        'Contact List': [
            'Id Number','Practitioner Last Name','Practitioner First Name','Practitioner Middle Initial','Degree','Practitioner Facility Expertise','Mobile Phone','Email Address'
        ],
        'Item Master': [
            'Purchase Item','Item Name','Last PO Date','Supplier ID','Supplier Name','Supplier Item Identifier','Supplier Item Identifier (No Special Characters)',
            'Manufacturer Reference ID','Manufacturer Name','Manufacturer Part Number (No Special Characters)','Manufacturer Part Number','Supplier Contract',
            'Unit Price','Excellian Average Cost','Excellian Conversion Factor','Prior Year End Standard Cost','Base Unit Of Measure','Default Stocking UOM',
            'Default Ordering UOM','Packaging String','Contract Manager (Buyer)','Contract Specialist','Expiration Date','Purchase Item Group Desc',
            'Purchase Item Group ID','Spend Category Code','Spend Category Name','Contract Category','Hazard Code','UNSPSC','Default Tax Applicability','Formulary',
            'Robotics Flag','Limited Use Flag','Item Active Flag','Item ID','Sourcing Priority CD'
        ],
    },
    '8': {
        'Log Usage': [
            'LOGID', 'PICK_LIST_ID', 'SUPPLY_ID', 'SUPPLY_NAME', 'SUPPLIES_USED', 'SUPPLIES_WASTED',
            'NUMBER_PULLED_PRN', 'NUMBER_PULLED_OPEN', 'PICK_LIST_NAME', 'SURGERY_DATE', 'COST',
            'CAT_NUMBER', 'MNFCTR_ID', 'OR_SERVICE_ID', 'OR_SERVICE', 'MANUFACTURER',
            'OR_LOCATION_ID', 'OR_LOCATION_NAME'
        ],
        'Picklist Data': [
            'LOGID', 'CARD_NUMBER', 'ALL_DEF_OR_PROC_ID', 'ALL_PROCS_PANEL', 'ORDINAL',
            'PICK_LIST_ID', 'PICK_LIST_NAME', 'SURGEON_ID', 'SURGEON_ORDER', 'SURGEON_NAME',
            'PROCEDURE_ID', 'PROCEDURE_NAME', 'OR_SERVICE_ID', 'OR_SERVICE',
            'OR_LOCATION_ID', 'OR_LOCATION'
        ],
        'Preference Card Data': [
            'CARD_NUM', 'PICKLIST_ID', 'SUPPLY_ID', 'SUPPLY_NAME',
            'PULLED_PRN', 'PULLED_AS_OPEN', 'CARD_OWNER', 'EPIC_PROV_ID',
            'COST', 'CAT_NUM', 'MNFCTR_ID', 'MANUFACTURER', 'SUPPLY_TYPE'
        ],
        'Preference Card List': [
            'CARD_NAME', 'CARD_NUMBER', 'PROCEDURE_ORDER', 'PROCEDURE_CODE',
            'PROCEDURE_NAME', 'LOCATION_ORDER', 'LOCATION_CODE', 'LOCATION_NAME'
        ]
    }
};

function ExpectedFilesList({ organizationId }) {
    const theme = useTheme();
    // Get expected files for the specific organization, fallback to default
    const expectedFiles = ORG_EXPECTED_FILES_WITH_HEADERS[organizationId] || DEFAULT_EXPECTED_FILES;

    return (
        <Box sx={{ 
            border: '1px solid', 
            borderColor: theme.palette.border.main, 
            borderRadius: 1, 
            p: 2, 
            backgroundColor: theme.palette.background.main,
            minWidth: '150px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Typography variant='heavy' fontSize='16px' sx={{ mb: 1 }}>
                Expected Files
            </Typography>
            <List dense py={0}>
                {Object.keys(expectedFiles).map((file_name, index) => (
                    <ListItem key={index} py={0.25} px={0}>
                        <ListItemText primary={file_name} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}

export default ExpectedFilesList;